/**
 * @namespace source.items.trash
 */
import { toItem } from './mappers/item';
import { toError } from './parsers/error';
import { initItems } from './items';
export function initItemsTrash(settings, http) {
  function mapItemList(res, thumbnailSizes) {
    res.data = (res.data.files || []).map(function (item) {
      const newItem = toItem(item, settings, thumbnailSizes);
      newItem.isInTrash = true;
      return newItem;
    });
    return res;
  }
  const items = initItems(settings, http);
  const defaultPaging = {
    size: 50,
    cursor: null
  };
  const defaultSort = {
    order: 'date',
    direction: 'desc'
  };
  function list(folderId, options) {
    options = options || {};
    const sort = {
      ...defaultSort,
      ...options.sort
    };
    const paging = {
      ...defaultPaging,
      ...options.paging
    };
    const queryParams = {
      page_size: paging.size,
      cursor: paging.cursor,
      parent_folder_id: folderId,
      media_type: options.mediaType
    };
    queryParams.order = sort.direction === 'desc' ? `-${sort.order}` : sort.order;
    if (settings.namespace) {
      queryParams.ns = settings.namespace;
    }
    return http.get(`${settings.apiUrl}/go/site/media/trash/files`, queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        size: paging.size,
        cursor: response.data.cursor
      };
      return mapItemList(response, options.thumbnails);
    }).catch(toError);
  }
  function search(folderId, query, options) {
    return items.search(folderId, query, options).then(response => {
      response.data = response.data.map(item => {
        item.isInTrash = true;
        return item;
      });
      return response;
    }).catch(toError);
  }
  return {
    list,
    search
  };
}